/*jshint esversion: 6 */

/**
 * Show/hide toggle for artist lists from earlier festival years.
 *
 * The markup ships with the list behind the `hidden` attribute. Browsers do not
 * fetch `loading="lazy"` images inside a hidden subtree, so the artwork for
 * earlier years costs nothing until the visitor opens that year.
 */
document.addEventListener('DOMContentLoaded', () => {
	const toggles = document.querySelectorAll('.artist-items-toggle');

	toggles.forEach((toggle) => {
		const items = document.getElementById(
			toggle.getAttribute('aria-controls')
		);

		if (!items) {
			return;
		}

		toggle.addEventListener('click', () => {
			const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

			toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
			items.hidden = isExpanded;
			items.classList.toggle('is-collapsed', isExpanded);
		});
	});
});
